import { z } from 'zod';

import dayjs from '@/js/libs/dayjs';

import type { ForecastSearchParameters } from 'src/types';
import { ForecastSearchKey } from 'src/types';

export const tomorrow = dayjs(new Date()).startOf('day').utc().add(1, 'day');

export enum MediaType {
  ANALOG = 'ANALOG',
  DIGITAL = 'DIGITAL',
}

export const forecastRouterSearchParamsSchema = z.object({
  [ForecastSearchKey.SEARCH]: z.custom<ForecastSearchParameters>().optional(),
});
